import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Slider, { createSliderWithTooltip } from "rc-slider";
import { Popup } from "../../../library/popup";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import {
  changeOverviewModal,
  requestDeleteGoal,
  requestUpdateGoal,
} from "../../../../redux/actions/overview";
import {
  FadeButton,
  SolidButton,
  TransparentButton,
} from "../../../library/button";
import { sendErrorNotification } from "../../../universal/notifications/notifications";
import moment from "moment";
import { Input } from "../../../library/input";
import { Label } from "../../../library/label";
import "rc-slider/assets/index.css";
import "./style.scss";

const SliderWithTooltip = createSliderWithTooltip(Slider);

const Index = () => {
  const dispatch = useDispatch();

  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );
  const goalData = useSelector((state) => state.overview.fetchGoals.status);
  const activeUpdate = useSelector((state) => state.overview.activeUpdateGoal);
  const modalState = useSelector(
    (state) => state.overview.showModals.editGoalModal
  );

  const [goalObject, setGoalObject] = useState({});

  const updateLoading = useSelector(
    (state) => state.overview.updateGoal.loading
  );
  const deleteLoading = useSelector(
    (state) => state.overview.deleteGoal.loading
  );

  const handleClose = () => {
    dispatch(changeOverviewModal({ editGoalModal: false }));
  };

  const clickUpdateGoal = () => {
    if (goalObject && goalObject.amount && goalObject.start && goalObject.end) {
      const trimmedObject = { ...goalObject };
      trimmedObject["start"] = moment(trimmedObject.start).unix();
      trimmedObject["end"] = moment(trimmedObject.end).unix();

      if (trimmedObject.end > trimmedObject.start) {
        dispatch(
          requestUpdateGoal({
            companyId: selectedCompany,
            goal: trimmedObject,
            id: goalData.id,
          })
        );
      } else {
        sendErrorNotification("Start kan ikke være senere enn slutt.");
      }
    } else {
      sendErrorNotification("Vennligst fyll inn alle felter.");
    }
  };

  const clickDeleteGoal = () => {
    if (goalData && goalData.id) {
      dispatch(
        requestDeleteGoal({ companyId: selectedCompany, goalId: goalData.id })
      );
    }
  };

  useEffect(() => {
    if (Object.keys(activeUpdate).length > 0) {
      setGoalObject({
        amount: activeUpdate.amount,
        start: activeUpdate.start,
        end: activeUpdate.end,
      });
    }
  }, [activeUpdate]);

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Endre eksisterende mål"
      description="Du kan endre på det eksisterende målet ved å justere verdiene i skjemaet nedenfor."
      buttons={[
        <TransparentButton
          title="Avbryt"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        <SolidButton
          color="blue"
          title={updateLoading ? "Oppdaterer mål.." : "Oppdater mål"}
          icon={
            updateLoading ? (
              <i className="fas fa-circle-notch fa-spin"></i>
            ) : (
              <i className="fas fa-plus"></i>
            )
          }
          onClick={() => clickUpdateGoal()}
          type="button"
        />,
      ]}
    >
      <div className="edit-goal-modal-content">
        <div className="edit-goal-content-container">
          <div className="single-detail-container">
            <Row className="info-row">
              <Col className="info-col">
                <Label version={1} weight="bold">
                  Antall
                </Label>
                <SliderWithTooltip
                  min={0}
                  max={100}
                  marks={{ 0: 0, 100: 100 }}
                  handleStyle={{
                    backgroundColor: "#fff",
                    border: "2px solid #F5F5F5",
                    height: 16,
                    width: 16,
                  }}
                  trackStyle={{ backgroundColor: "#3699FF", height: 7 }}
                  railStyle={{ backgroundColor: "#e3ebff", height: 7 }}
                  dotStyle={{ display: "none" }}
                  value={goalObject.amount}
                  onChange={(val) =>
                    setGoalObject({ ...goalObject, amount: val })
                  }
                  className="value-slider"
                />
              </Col>
            </Row>
          </div>
          <div className="single-detail-container">
            <Row className="info-row">
              <Col className="info-col" md={6}>
                <Label version={1} weight="bold">
                  Start
                </Label>
                <Input
                  value={goalObject.start}
                  onChange={(e) =>
                    setGoalObject({ ...goalObject, start: e.target.value })
                  }
                  type="date"
                />
              </Col>
              <Col className="info-col" md={6}>
                <Label version={1} weight="bold">
                  Slutt
                </Label>
                <Input
                  value={goalObject.end}
                  onChange={(e) =>
                    setGoalObject({ ...goalObject, end: e.target.value })
                  }
                  type="date"
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <ToastContainer />
    </Popup>
  );
};

export default Index;
